import { IIconProps } from '#components/icons/types';
const Close = ({ size = 24, color = '#ffffff' }: IIconProps) => {
  return (
    <svg className="svg-icon" viewBox="0 0 24 24" width={size} height={size}>
      <path d="M0 0h24v24H0z" fill="none" stroke="none" />
      <path
        fill={color}
        d="M6.3 18.9 5.15 17.7 10.825 12 5.15 6.25 6.3 5.05 12.025 10.8 17.7 5.05 18.85 6.25 13.175 12 18.85 17.7 17.7 18.9 12.025 13.15Z"
      />
    </svg>
  );
};

export default Close;
